import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	event: null,
	loading: true,
	loadingRequestSubmit: false,
	loadingVerifySubmit: false
};

export default function loginPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.LOGIN_REQUEST_OTP_REQUEST:
		case ActionTypes.LOGIN_REQUEST_OTP_SUCCESS:
		case ActionTypes.LOGIN_REQUEST_OTP_ERROR:
		case ActionTypes.LOGIN_VERIFY_OTP_REQUEST:
		case ActionTypes.LOGIN_VERIFY_OTP_SUCCESS:
		case ActionTypes.LOGIN_VERIFY_OTP_ERROR:
		case ActionTypes.GET_PUBLISHED_EVENT_REQUEST:
		case ActionTypes.GET_PUBLISHED_EVENT_ERROR:
		case ActionTypes.GET_PUBLISHED_EVENT_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_LOGIN_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_LOGIN_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
